import { render, staticRenderFns } from "./CleaveElement.vue?vue&type=template&id=cb2ebb08&scoped=true&"
import script from "./CleaveElement.vue?vue&type=script&lang=js&"
export * from "./CleaveElement.vue?vue&type=script&lang=js&"
import style0 from "./CleaveElement.vue?vue&type=style&index=0&id=cb2ebb08&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb2ebb08",
  null
  
)

export default component.exports